import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9aa9004a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9aa9004a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aa9004a')) {
      api.createRecord('9aa9004a', component.options)
    } else {
      api.reload('9aa9004a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9aa9004a", function () {
      api.rerender('9aa9004a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabInputs/index.vue"
export default component.exports